import type React from "react";

import type { ActiveSession } from "@/feature-auth/models/active-session-model.mjs";
import type { User } from "@/feature-auth/models/user-model.mjs";
import { proxy } from "@/util/proxy.mjs";

interface SettingsRefs {
  settingsListItems: Array<React.FC>;

  removeSession: (sessionIds: string[]) => Promise<ActiveSession>;

  GameSettings: React.FC;

  Edit: React.FC<{
    editClick: (modal: string) => void;
    modal: string;
  }>;

  UserSettings: React.FC<{
    user: User;
    close: () => void;
    setSnackbarText: (translation: Translation) => void;
  }>;

  DeleteUser: React.FC<{
    user: User;
    close: () => void;
    setSnackbarText: (translation: Translation) => void;
  }>;

  EditEmail: React.FC<{
    user: User;
    close: () => void;
    setSnackbarText: (translation: Translation) => void;
  }>;
}

export const settingsRefs = proxy<SettingsRefs>({
  settingsListItems: [],

  GameSettings: () => null,
  Edit: () => null,
  UserSettings: () => null,
  removeSession: () => null,
  DeleteUser: () => null,
  EditEmail: () => null,
});

export default settingsRefs;
